import { instance } from '@/services/avik-api-gateway'
import { VehicleTypeGroup } from '@/types/vehicle-type-group'
import { AxiosResponse } from 'axios'

export function updateVehicleTypeGroup(
  body: VehicleTypeGroup
): Promise<AxiosResponse<VehicleTypeGroup>> {
  return instance.put(`/vehicle-type-group/${body.uuid}`, body)
}
